import { indexData } from '@/mocks/homeData';

const iconBgColors = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
  'bg-primary-100 text-primary-600',
  'bg-secondary-100 text-secondary-600',
  'bg-accent-100 text-accent-600',
  'bg-secondary-100 text-secondary-600',
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            <span>分类索引</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫画分类 · 精准找到你爱看的
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            八大主题分类，从恋爱到悬疑，每一种类型都有海量好漫等你发现
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-4 md:p-5 cursor-pointer hover:bg-background-50 transition-all duration-200 hover:-translate-y-1 text-center"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 mx-auto rounded-xl flex items-center justify-center mb-3 ${iconBgColors[idx]}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-primary-500 font-medium mb-1.5">{item.count}</p>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}